module.exports = __webpack_public_path__ + "static/media/Rowena_with_Martin_Smith.32690ca3.jpg";